import React from "react";

const Link = ({ href="", ...props }) => {
    const anchorProps = React.useMemo(() => ({
        href,
        nofollow: true,
        noopener: true,
        noreferrer: true,
        target: href?.startsWith("http") ? "_blank" : "",
    }), [href]);
    return <a { ...anchorProps } { ...props} />
}

export default Link;